<div class="relative" [class]="widthClass + ' ' + heightClass">
  <div
    class="relative w-full h-full cursor-pointer rounded-lg border-2 border-dashed flex items-center justify-center transition-all duration-200"
    [class.border-gray-300]="!isDragging" [class.border-blue-500]="isDragging" [class.bg-blue-50]="isDragging"
    [class.cursor-not-allowed]="readonly" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)">

    <div *ngIf="imageUrl" class="relative w-full h-full overflow-hidden">
      <img [src]="imageUrl" class="w-full h-full object-cover" alt="Uploaded image">
    </div>

    <div *ngIf="isAssetLoading" class="absolute inset-0 bg-white bg-opacity-80 flex items-center justify-center">
      <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></div>
    </div>

    <div *ngIf="!imageUrl" class="flex flex-col items-center justify-center p-4 text-gray-500">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-10 w-10 mb-2" fill="none" viewBox="0 0 24 24"
        stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
      </svg>
      <p *ngIf="showInstructions" class="text-sm">Drag and drop an image here or click to select</p>
    </div>

    <input [id]="inputId" type="file" class="hidden" accept="image/*" [disabled]="readonly"
      (change)="onFileChanged($event)">

    <label [for]="inputId" class="absolute inset-0 cursor-pointer" [class.cursor-not-allowed]="readonly">
    </label>
  </div>

  <button *ngIf="imageUrl && !readonly"
    class="absolute -top-1.5 -right-1.5 z-20 p-1 rounded-full bg-gray-800 hover:bg-gray-700 transition-all duration-200 flex items-center justify-center min-w-[18px] min-h-[18px] shadow-sm"
    (click)="clearImage(); $event.stopPropagation()">
    <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3 text-white" viewBox="0 0 20 20" fill="currentColor">
      <path fill-rule="evenodd"
        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
        clip-rule="evenodd" />
    </svg>
  </button>

  <button *ngIf="imageUrl && enableZoom"
    class="absolute bottom-1 left-1 z-20 p-1 rounded-full bg-gray-800 hover:bg-gray-700 transition-all duration-200 flex items-center justify-center min-w-[18px] min-h-[18px] shadow-sm"
    (click)="openZoomDialog(zoomDialog); $event.stopPropagation()">
    <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3 text-white" viewBox="0 0 20 20" fill="currentColor">
      <path fill-rule="evenodd"
        d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
        clip-rule="evenodd" />
      <path fill-rule="evenodd" d="M8 5a1 1 0 011 1v1h1a1 1 0 110 2H9v1a1 1 0 11-2 0V9H6a1 1 0 110-2h1V6a1 1 0 011-1z"
        clip-rule="evenodd" />
    </svg>
  </button>
</div>

<ng-template #zoomDialog>
  <div class="p-4 bg-white rounded-lg">
    <div class="flex justify-end mb-2">
      <button mat-icon-button mat-dialog-close class="text-gray-500 hover:text-gray-700">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
    <div class="flex items-center justify-center">
      <img [src]="imageUrl" class="max-w-full max-h-[70vh] object-contain" alt="Zoomed image">
    </div>
  </div>
</ng-template>